{
  "cards": [
    {
      "title": "MultiSport Plus",
      "text": "Jedyna na rynku karta umożliwiająca wielokrotne korzystanie z obiektów sportowych jednego dnia.",
      "image": {
        "url": "/images/cards/card_1.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Classic",
      "text": "Codziennie korzystaj z tysięcy obiektów w Polsce.",
      "image": {
        "url": "/images/cards/card_2.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Light",
      "text": "Rozbudź zapał do aktywności trenując 6-8 razy w miesiącu.",
      "image": {
        "url": "/images/cards/card_3.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    }
  ],
  "cards2": [
    {
      "title": "MultiSport Student",
      "text": "Stworzona z myślą o osobach między 15. a 26. rokiem życia.",
      "image": {
        "url": "/images/cards/card_6.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Senior",
      "text": "Zadbaj o aktywność bliskich powyżej 60. roku życia.",
      "image": {
        "url": "/images/cards/card_5.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Kids",
      "text": "Wstęp dla najmłodszych do tysięcy obiektów nawet kilka razy dziennie.",
      "image": {
        "url": "/images/cards/card_4.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Kids Aqua",
      "text": "Dla dzieci do 15. roku życia, kochających wodne rozrywki.",
      "image": {
        "url": "/images/cards/card_7.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    }
  ]
}